var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6324 25.9667C17.2991 25.9667 16.9824 25.8333 16.7491 25.6L12.0324 20.8833C11.5491 20.4 11.5491 19.6 12.0324 19.1167C12.5158 18.6333 13.3158 18.6333 13.7991 19.1167L17.6324 22.95L26.1991 14.3833C26.6824 13.9 27.4824 13.9 27.9658 14.3833C28.4491 14.8667 28.4491 15.6667 27.9658 16.15L18.5158 25.6C18.2824 25.8333 17.9658 25.9667 17.6324 25.9667Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons1);
export default __webpack_public_path__ + "static/media/Icons (1).d03bfac09c0f34933d4ea3cb9c70e3b1.svg";
export { ForwardRef as ReactComponent };